import { Fragment, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import styled from "styled-components";
import { Thumbs } from "swiper";
import {
  ICategoryProduct,
  IMeta,
  IProductDetail,
  IProductDetailGeneric,
  IRelateds,
} from "global-types/global.types";
import Left from "@/assets/img/arrowBlack.svg";
import FancyboxTools from "@/components/Ui/Tools/FancyBox/FancyBox";
import Image from "next/image";

interface Props {
  data: IProductDetail<
    IProductDetailGeneric<ICategoryProduct, IMeta, IRelateds[]>
  >;
}

export default function ProductDetailCarousel({ data }: Props) {
  const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);
  const defaultImages = [data.data.thumbnail];

  const images =
    data?.data.images.length > 0
      ? data?.data.images.map((item) => `${item.url}`)
      : [];

  const slideIMG2 =
    images?.length > 0 ? (
      images?.map((img, index) => {
        if (index === 0) {
          return (
            <Fragment key={index.toString() + "img2"}>
              <SwiperSlide tag="li">
                <Image
                  width={400}
                  height={400}
                  data-fancybox="gallery"
                  data-src={`${data.data.thumbnail}`}
                  src={`${data.data.thumbnail}`}
                  style={{ listStyle: "none" }}
                  alt={data.data.title}
                />
              </SwiperSlide>
              <SwiperSlide
                id="large-slide"
                tag="a"
                key={index.toString() + img}
              >
                <Image
                  width={400}
                  height={400}
                  src={img}
                  data-fancybox="gallery"
                  data-src={img}
                  style={{ listStyle: "none" }}
                  alt={data.data.title}
                />
              </SwiperSlide>
            </Fragment>
          );
        }

        return (
          <SwiperSlide
            id="large-slide"
            tag="a"
            key={index.toString() + "img2New"}
          >
            <Image
              width={400}
              height={400}
              src={img}
              data-fancybox="gallery"
              data-src={img}
              style={{ listStyle: "none" }}
              alt={data.data.title}
            />
          </SwiperSlide>
        );
      })
    ) : (
      <SwiperSlide id="large-slide" tag="a">
        <Image
          width={400}
          height={400}
          data-fancybox="gallery"
          data-src={defaultImages[0]}
          src={defaultImages[0]}
          style={{ listStyle: "none" }}
          alt={data.data.title}
        />
      </SwiperSlide>
    );




  const slideIMG =
    images?.length > 0 ? (
      images?.map((img, index) => {
        if (index === 0) {
          return (
            <Fragment key={index.toString() + "img1"}>
              <SwiperSlide tag="li">
                <Image
                  width={400}
                  height={400}
                  src={`${data.data.thumbnail}`}
                  style={{ listStyle: "none" }}
                  alt={data.data.title}
                />
              </SwiperSlide>
              <SwiperSlide>
                <Image
                  width={400}
                  height={400}
                  src={`${img}`}
                  style={{ listStyle: "none" }}
                  alt={data.data.title}
                />
              </SwiperSlide>
            </Fragment>
          );
        }

        return (
          <SwiperSlide key={index.toString() + "img1Setup"} tag="li">
            <Image
              width={400}
              height={400}
              src={`${img}`}
              style={{ listStyle: "none" }}
              alt={data.data.title}
            />
          </SwiperSlide>
        );
      })
    ) : (
      <SwiperSlide id="large-slide" tag="a">
        <Image
          width={400}
          height={400}
          src={defaultImages[0]}
          style={{ listStyle: "none" }}
          alt={data.data.title}
        />
      </SwiperSlide>
    );

  return (
    <Wrapper>
      <FancyboxTools options={{ infinite: false }}>
        <Swiper
          modules={[Thumbs]}
          thumbs={{
            swiper:
              thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
          }}
          id="main-carousel"
          tag="section"
          wrapperTag="div"
          navigation          
          spaceBetween={0}
          slidesPerView={1}
        >
          {slideIMG2}
        </Swiper>

        <Swiper
          modules={[Thumbs]}
          watchSlidesProgress
          onSwiper={setThumbsSwiper}
          id="thumbs"
          spaceBetween={8}
          slidesPerView={5}
          direction={"horizontal"}
        >
          {slideIMG}
        </Swiper>
      </FancyboxTools>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .swiper-slide-thumb-active {
    border: 1px solid #fa8600;
    border-radius: 5px;
  }

  .product-detail-page .swiper-slide {
    background: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .swiper-wrapper {
    padding-inline-start: 0;
    width: 100%;
  }

  #main-carousel {
    max-height: 100%;
    max-width: 555px;
    height: auto;
    width: 100%;
    margin-left: 0;

    .css-13uajvl {
      padding-bottom: 1.2rem !important;

      a {
        background-size: cover;
      }
    }

    @media only screen and (max-width: 768px) {
      width: 100%;
      height: 220px;
      max-width: 100%;
    }

    .swiper-button-prev {
      background-image: url(${Left.src});
      background-repeat: no-repeat;
      background-size: cover;
      width: 29px;
      height: 19px;
      transform: rotate(90deg);
      position: absolute;
      left: 0;
      z-index: 10;

      &:after {
        display: none;
      }

      @media only screen and (max-width: 768px) {
        display: block;
      }
    }

    .swiper-button-next {
      background-image: url(${Left.src});
      background-repeat: no-repeat;
      background-size: contain;
      width: 29px;
      height: 19px;
      transform: rotate(-90deg);
      position: absolute;
      right: 0;
      z-index: 10;

      &:after {
        display: none;
      }

      @media only screen and (max-width: 768px) {
        display: block;
      }
    }

    .swiper-slide {
      width: 100%;
      height: auto;
      height: 46rem;

      div {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      @media only screen and (max-width: 768px) {
        width: 100%;
        height: 100%;
      }

      @media only screen and (max-width: 600px) {
        width: 100%;
        height: 100%;
      }

      @media only screen and (max-width: 400px) {
        width: 100%;
        height: auto;
      }

      img {
        width: 100% !important;
        height: auto !important;
        height: 458px !important;
        object-fit: contain;
        object-position: center;
        border-radius: 12px;

        @media (max-width: 768px) {
          height: 60vh !important;
          object-fit: contain;
          object-position: center;
          max-height: 100%;
        }

        @media (max-width: 575px) {
          height: 200px !important;
          object-position: center !important;
        }
      }
    }
  }

  #thumbs {
    width: 100%;
    height: 100%;
    margin-left: 0;
    margin-top: 12px;

    @media only screen and (max-width: 768px) {
      display: none;
    }

    .swiper-slide {
      height: 98px;
      width: 72px;

      img {
        height: 100%;
        width: 100%;
        object-fit: contain;
        border-radius: 6px;
      }
    }
  }

  #carousel-custom {
    grid-column: 1/7;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    height: 100%;

    @media only screen and (max-width: 768px) {
      grid-column: 1/-1;
      height: 100%;
    }

    .loader-container {
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .css-1x4ynwp,
  .SRLCaptionText {
    display: none !important;
  }

  .css-10yc0wa {
    background-color: rgba(30, 30, 30, 0.5) !important;
  }

  .SRLAutoplayButton.css-1ajrsxg,
  .css-ty58x7,
  .css-tcq89j,
  .css-10znog8,
  .css-h9a1eb,
  .css-1n6vy4l {
    border-radius: 50% !important;
    // background-color: #1B1C1F !important;
    display: flex;
    align-items: center;
    justify-content: center;
    background: radial-gradient(
      90.16% 143.01% at 15.32% 21.04%,
      rgba(165, 239, 255, 0.2) 0%,
      rgba(110, 191, 244, 0.0447917) 77.08%,
      rgba(70, 144, 213, 0) 100%
    ) !important;
    background-blend-mode: overlay, normal !important;
    backdrop-filter: blur(80px) !important;
  }

  .SRLAutoplayButton.css-1ajrsxg,
  .css-ty58x7,
  .css-tcq89j,
  .css-10znog8,
  .css-h9a1eb,
  .css-1n6vy4l {
    border-radius: 50% !important;
    // background-color: #1B1C1F !important;
    display: flex;
    align-items: center;
    justify-content: center;
    background: radial-gradient(
      90.16% 143.01% at 15.32% 21.04%,
      rgba(165, 239, 255, 0.2) 0%,
      rgba(110, 191, 244, 0.0447917) 77.08%,
      rgba(70, 144, 213, 0) 100%
    ) !important;
    background-blend-mode: overlay, normal !important;
    backdrop-filter: blur(80px) !important;
  }

  .SRLAutoplayButton.css-1ajrsxg svg path,
  .css-ty58x7 svg path,
  .css-tcq89j svg path,
  .css-10znog8 svg path,
  .css-h9a1eb svg path,
  .css-1n6vy4l svg path {
    fill: #fff !important;
  }

  // .magnifier {
  //   position: unset;

  //   .example-class {
  //     width: 6000;
  //     height: 60px;
  //   }

  //   .zoom {
  //     width: 100px;
  //     height: 100px;
  //     position: absolute;
  //   }

  //   .preview {
  //     position: absolute;
  //     top: 40px;
  //     left: 50px;
  //     height: 100%;
  //     width: 100%;
  //   }
  // }

  #large-slide {
    display: block;

    // @media only screen and (max-width: 768px) {
    //   display: none;
    // }
  }

  #small-slide {
    display: none;

    @media only screen and (max-width: 768px) {
      display: block;
    }
  }

  @media only screen and (max-width: 1128px) {
    #main-carousel {
      max-width: 100%;
    }
  }

  @media only screen and (max-width: 768px) {
    #main-carousel {
      max-width: 100%;
      margin-bottom: 12px;

      .swiper-slide {
        position: relative;
        padding-top: 100%;

        img {
          border-radius: 0 !important;
          // height: 420px !important;
          object-fit: contain;
          width: 100% !important;
          position: absolute;
          top: 0;
        }
      }
    }

    .product-name {
      font-size: 24px !important;
    }

    .product-price {
      flex-direction: row;
      align-items: center !important;
      margin-bottom: 24px;
      border-bottom: 1px solid rgba(68, 68, 68, 0.25);
      // padding-bottom: 24px;
    }

    #thumbs {
      display: none;
    }
  }
`;
